
/**
 * Constants used in the game
 */

// Maximum number of rounds allowed before the game ends in divergence
export const MAX_ROUNDS = 20;
